// packages imports
import { Grid } from '@mui/material'
import { useFormContext } from 'react-hook-form'
import { FC } from 'react'

// components imports
import BillingTypesList from './BillingTypesList'
import HybridBillingForm from './HybridBillingForm'
import FlatFeeBillingForm from './FlatFeeBillingForm'
import ContingencyHybridBillingForm from './ContingencyHybridBillingForm'
import HourlyBillingForm from './HourlyBillingForm'
import BillGenerationLimitForm from './BillGenerationLimitForm'
import BillApproverListForm from './BillApproverListForm'
import InterestForm from './InterestForm'
import DiscountForm from './DiscountForm'
import BillSplitForm from './BillSplitForm'
import ConsultBillingForm from './ConsultBillingForm'
import ContingencyBillingForm from './ContingencyBillingForm'

// others
import { BillingType } from '../../../../../generated'
import BillDeliveryForm from './BillDelivery'

interface BillingDetailsProps {
  isEdit?: boolean
}

const BillingDetails: FC<BillingDetailsProps> = ({ isEdit = false }) => {
  const { watch } = useFormContext()
  const [billingType] = watch(['billing.billingType'])

  return (
    <Grid container rowSpacing={2.5}>
      <Grid item xs={12}>
        <BillingTypesList isEdit={isEdit} />
      </Grid>

      {billingType === BillingType.Hybrid && <HybridBillingForm />}

      {billingType === BillingType.FlatFee && <FlatFeeBillingForm isEdit={isEdit} />}

      {billingType === BillingType.Contingency && <ContingencyBillingForm />}

      {billingType === BillingType.ContingencyHybrid && <ContingencyHybridBillingForm />}

      {billingType === BillingType.Hourly && <HourlyBillingForm />}

      {billingType === BillingType.Consult && <ConsultBillingForm />}

      {billingType !== BillingType.Consult && <BillGenerationLimitForm />}

      {billingType === BillingType.Hourly && <BillSplitForm />}

      <BillDeliveryForm isEdit={isEdit} />

      <BillApproverListForm isEdit={isEdit} />

      <InterestForm />

      {billingType !== BillingType.Consult && billingType !== BillingType.ProBono && <DiscountForm />}
    </Grid>
  )
}

export default BillingDetails
